// Default value for the applications store. Empty because nothing is pre-seeded —
// submissions only exist once a real human fills the recruit form.
export const APPLICATIONS = [];
